var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstitute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28223 14.2106H8.44889M7.28223 18.8773H8.44889M20.1156 18.8773H21.2822M20.1156 14.2106H21.2822M13.6989 14.2106H14.8656M11.9489 25.2939V20.6273C11.9489 19.3387 12.9935 18.2939 14.2822 18.2939C15.5709 18.2939 16.6156 19.3387 16.6156 20.6273V25.2939M20.1156 9.54401L21.9543 10.0037C22.9655 10.2565 23.471 10.3829 23.8475 10.6647C24.1795 10.9134 24.4393 11.2462 24.6001 11.6287C24.7822 12.0622 24.7822 12.5833 24.7822 13.6255V21.5606C24.7822 22.8675 24.7822 23.5208 24.5279 24.0199C24.3042 24.4591 23.9472 24.816 23.5082 25.0397C23.0091 25.2939 22.3557 25.2939 21.0489 25.2939H7.51556C6.20878 25.2939 5.55537 25.2939 5.05625 25.0397C4.6172 24.816 4.26024 24.4591 4.03655 24.0199C3.78223 23.5208 3.78223 22.8675 3.78223 21.5606V13.6255C3.78223 12.5833 3.78223 12.0622 3.96438 11.6287C4.12509 11.2462 4.38489 10.9134 4.71701 10.6647C5.09343 10.3829 5.59898 10.2565 6.61009 10.0037L8.44889 9.54401L11.7848 6.54173C12.6674 5.74727 13.1089 5.35004 13.608 5.19938C14.0477 5.06668 14.5167 5.06668 14.9564 5.19938C15.4555 5.35004 15.897 5.74727 16.7797 6.54173L20.1156 9.54401Z",
    stroke: "#173CBA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitute);
export default __webpack_public_path__ + "static/media/institute.afda6478aa96dadd04fc9b49ffc56b9d.svg";
export { ForwardRef as ReactComponent };